import { Injectable } from '@angular/core';

declare const window: any;
declare const tapps: any;

@Injectable({
  providedIn: 'root',
})
export class TAppService {
  constructor() {}

  /**
   * Tアプリか判断
   * @returns boolean
   */
  isTapp() {
    return (
      navigator.userAgent.match(/T\-SITE ver\/(\d+)\.(\d+)\.(\d+)/) !== null
    );
  }

  /**
   * Tアプリか判断し特定のバージョン以上かをチェックする
   * @returns boolean
   */
  isTappAndVersionCheck(minX: number, minY: number = 0, minZ: number = 0) {
    const match = navigator.userAgent.match(/T\-SITE ver\/(\d+)\.(\d+)\.(\d+)/);
    if (!match) return false;

    const ver = {
      x: parseInt(match[1]),
      y: parseInt(match[2]),
      z: parseInt(match[3]),
    };

    if (ver.x >= minX && ver.y >= minY && ver.z >= minZ) {
      return true;
    }

    return false;
  }

  /**
   * Tアプリ内でモーダル表示のリンクを行う
   */
  openView(url: string): void {
    const ua = navigator.userAgent.toLowerCase();

    if (/ip(hone|(o|a)d)/.test(ua)) {
      window.webkit.messageHandlers.openView.postMessage([url]);
      return;
    }

    if (ua.indexOf('android') > 0) {
      tapps.openView(url);
    }
  }
}
